export default __webpack_public_path__ + "static/media/509.a797f300.png";